import { useEffect } from 'react';

/** Calls `onClose` on Escape while `active`. */
export function useCloseOnEscape(active: boolean, onClose: () => void) {
    useEffect(() => {
        if (!active) return;

        const handleKeyDown = (event: KeyboardEvent) => {
            if (event.key === 'Escape') onClose();
        };

        document.addEventListener('keydown', handleKeyDown);
        return () => document.removeEventListener('keydown', handleKeyDown);
    }, [active, onClose]);
}
